import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './scss/style.scss';

Vue.config.productionTip = false;

Vue.use(VueCarousel, {
  perPage: 1,
  perPageCustom: [
    [1768, 3],
  ],
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
